import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
    },
    contentBtn: {
        position: 'absolute',
        bottom: 60,
        paddingHorizontal: 25,
        width: '100%'
    },
    btn: {
        padding: 10,
        borderRadius: 20
    },
    PickerSelect: {
        borderRadius: 4,
        paddingHorizontal: 10,
        height: 40,
        marginTop: 10,
        color: '#222'
    },
    textBtn: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: '500'
    }
});

export default styles;
